/**
 * Finds the pixel coordinates of each edge of an elements
 * bounding box and the box's width & height
 */

export const getElementBoundingBox = (el) => {
  const rect = el.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width,
  };
};

// calculates the available space between an anchor and container

export const getAvailableSpace = (anchor, container, buffer, offset, side) => ({
  bottom:
    container.bottom -
    anchor.bottom -
    buffer -
    (side === 'bottom' ? offset : 0),
  left: anchor.left - container.left - buffer - (side === 'left' ? offset : 0),
  right:
    container.right - anchor.right - buffer - (side === 'right' ? offset : 0),
  top: anchor.top - container.top - buffer - (side === 'top' ? offset : 0),
});

// Calculates the intersection space between two bounding boxes
export const intersectBoundingBoxes = (first, second) => {
  if (first && second) {
    const intersection = {
      bottom: Math.min(first.bottom, second.bottom),
      left: Math.max(first.left, second.left),
      right: Math.min(first.right, second.right),
      top: Math.max(first.top, second.top),
    };

    intersection.height = Math.max(intersection.bottom - intersection.top, 0);
    intersection.width = Math.max(intersection.right - intersection.left, 0);
    return intersection;
  }
  return first || second;
};

/**
 * Computes the fit (overlap) of content within a container
 * fit is in a range 0.0 => 1.0
 */

export const getVisibleFit = (content, container) => {
  const intersection = intersectBoundingBoxes(content, container);
  if (intersection.left > intersection.right) {
    // There is no intersection the boxes are separated on at least on axis
    return 0;
  }

  const intersectionArea =
    (intersection.right - intersection.left) *
    (intersection.bottom - intersection.top);
  const contentArea =
    (content.right - content.left) * (content.bottom - content.top);
  return intersectionArea / contentArea;
};
